export function formatErrorMessage(error, i18nMessage) {
  let customMessage = i18nMessage ? i18nMessage : '';
  let messageFromErrorArray =
    error &&
    error.data &&
    error.data.errors &&
    error.data.errors[0] &&
    error.data.errors[0].message;
  return messageFromErrorArray
    ? messageFromErrorArray
    : error && error.statusText
      ? error.statusText
      : customMessage;
}
